import { create } from 'zustand'
import type { Session, User } from '@supabase/supabase-js'
import { supabase } from '@/lib/supabase'

interface AuthState {
  session: Session | null
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  userId: string | null
  email: string | null

  setSession: (session: Session | null) => void
  setLoading:  (loading: boolean) => void
  signOut: () => Promise<void>
}

export const useAuthStore = create<AuthState>((set) => ({
  session:         null,
  user:            null,
  isLoading:       true,
  isAuthenticated: false,
  userId:          null,
  email:           null,

  setSession: (session) =>
    set({
      session,
      user:            session?.user ?? null,
      isLoading:       false,
      isAuthenticated: !!session,
      userId:          session?.user?.id ?? null,
      email:           session?.user?.email ?? null,
    }),

  setLoading: (isLoading) => set({ isLoading }),

  signOut: async () => {
    await supabase.auth.signOut()
    set({
      session: null, user: null,
      isAuthenticated: false, userId: null, email: null,
    })
  },
}))
